//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '~/components/Shared/Button.vue'
export default {
  components: {
    Button,
  },
  props: {
    changeLoginLabel: {
      type: String,
      default: 'Ingresar como Admin',
    },
    changeLoginPath: {
      type: String,
      default: '/login/admin',
    },
  },
}
